/**
 * TanStack Query hooks for `cap-over-delivery-cancel`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	capOverDeliveryCancelQueryKeys,
	type CreateCapOverDeliveryCancelBody,
	type ListCapOverDeliveryCancelResponse,
	type CapOverDeliveryCancelRow,
} from "./api";

export function useCapOverDeliveryCancelList(): UseQueryResult<ListCapOverDeliveryCancelResponse, Error> {
	return useQuery({
		queryKey: capOverDeliveryCancelQueryKeys.list(),
		queryFn: list,
	});
}

export function useCapOverDeliveryCancelCreate(): UseMutationResult<CapOverDeliveryCancelRow, Error, CreateCapOverDeliveryCancelBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: capOverDeliveryCancelQueryKeys.all });
		},
	});
}

export function useCapOverDeliveryCancelDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: capOverDeliveryCancelQueryKeys.all });
		},
	});
}
